const CATALOG_CARD_GAP = 20;
const CATALOG_COMPACT_CARD_GAP = 12;
const CATALOG_COMPACT_BREAKPOINT = 1440;
const CATALOG_LAYOUT_BREAKPOINT = 1220;
const CATALOG_FILTER_TOGGLE_BREAKPOINT = 1023;
const CATALOG_STACK_BREAKPOINT = 599;

export const catalogCardGridCompactMq = `@media (max-width: ${CATALOG_COMPACT_BREAKPOINT}px)`;
const catalogFilterToggleMq = `@media (max-width: ${CATALOG_FILTER_TOGGLE_BREAKPOINT}px)`;
const catalogStackMq = `@media (max-width: ${CATALOG_STACK_BREAKPOINT}px)`;
const catalogLayoutNarrowMq = `@media (max-width: ${CATALOG_LAYOUT_BREAKPOINT - 1}px)`;

const CATALOG_CARDS_WIDTH = "75%";
const CATALOG_CARD_WIDTH = `calc(33.333% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_CARDS_WIDTH_WIDE = "67%";
const CATALOG_CARD_WIDTH_WIDE = `calc(50% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_CARD_WIDTH_1023 = "calc(50% - 10px)";
const CATALOG_CARD_WIDTH_COMPACT = `calc(33.333% - ${CATALOG_COMPACT_CARD_GAP}px)`;
const CATALOG_CARD_WIDTH_WIDE_COMPACT = `calc(50% - ${CATALOG_COMPACT_CARD_GAP}px)`;
const CATALOG_DRAFTS_CARD_WIDTH = `calc(25% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_DRAFTS_CARD_WIDTH_COMPACT = `calc(25% - ${CATALOG_COMPACT_CARD_GAP}px)`;
const CATALOG_DRAFTS_CARD_WIDTH_NARROW = `calc(33.333% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_DRAFTS_CARD_WIDTH_NARROW_COMPACT = `calc(33.333% - ${CATALOG_COMPACT_CARD_GAP}px)`;

const catalogFiltersVisibleMq = `@media (min-width: ${CATALOG_FILTER_TOGGLE_BREAKPOINT + 1}px)`;

export const catalogCardsGridSx = {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    gap: `${CATALOG_CARD_GAP}px`,
    flexWrap: "wrap",
    [catalogCardGridCompactMq]: {
        gap: `${CATALOG_COMPACT_CARD_GAP}px`,
    },
    [catalogFilterToggleMq]: {
        gap: `${CATALOG_CARD_GAP}px`,
    },
    [catalogStackMq]: {
        gap: "16px",
    },
};

export const catalogCardsSectionSx = {
    boxSizing: "border-box",
    flex: `0 0 ${CATALOG_CARDS_WIDTH}`,
    width: CATALOG_CARDS_WIDTH,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    borderRight: (theme) => `${theme.palette.primary.main} 1px solid`,
    [catalogCardGridCompactMq]: {
        gap: "24px",
    },
    [catalogLayoutNarrowMq]: {
        flex: `0 0 ${CATALOG_CARDS_WIDTH_WIDE}`,
        width: CATALOG_CARDS_WIDTH_WIDE,
    },
    [catalogFilterToggleMq]: {
        flex: "0 0 100%",
        width: "100%",
        borderRight: "none",
    },
};

export const catalogShowMoreButtonWrapperSx = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
};

export const catalogDraftsCardsSectionSx = {
    boxSizing: "border-box",
    flex: "0 0 100%",
    width: "100%",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    [catalogCardGridCompactMq]: {
        gap: "24px",
    },
};

export const catalogCardWrapperSx = {
    width: CATALOG_CARD_WIDTH,
    containerType: "inline-size",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-start",
    position: "relative",
    overflow: "visible",
    "&:has(.catalog-card:hover)": {
        zIndex: 2,
    },
    [catalogCardGridCompactMq]: {
        width: CATALOG_CARD_WIDTH_COMPACT,
    },
    [catalogLayoutNarrowMq]: {
        width: CATALOG_CARD_WIDTH_WIDE_COMPACT,
    },
    [catalogFilterToggleMq]: {
        width: CATALOG_CARD_WIDTH_1023,
    },
    [catalogStackMq]: {
        width: "100%",
    },
};

/** На ширине с боковыми фильтрами каталога — на 1 колонку больше (4 вместо 3, 3 вместо 2). */
export const catalogDraftsCardWrapperSx = {
    containerType: "inline-size",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-start",
    position: "relative",
    overflow: "visible",
    "&:has(.catalog-card:hover)": {
        zIndex: 2,
    },
    width: CATALOG_CARD_WIDTH,
    [catalogCardGridCompactMq]: {
        width: CATALOG_CARD_WIDTH_COMPACT,
    },
    [catalogLayoutNarrowMq]: {
        width: CATALOG_CARD_WIDTH_WIDE_COMPACT,
    },
    [catalogFilterToggleMq]: {
        width: CATALOG_CARD_WIDTH_1023,
    },
    [catalogStackMq]: {
        width: "100%",
    },
    [catalogFiltersVisibleMq]: {
        width: CATALOG_DRAFTS_CARD_WIDTH,
        [catalogCardGridCompactMq]: {
            width: CATALOG_DRAFTS_CARD_WIDTH_COMPACT,
        },
        [catalogLayoutNarrowMq]: {
            width: CATALOG_DRAFTS_CARD_WIDTH_NARROW,
            [catalogCardGridCompactMq]: {
                width: CATALOG_DRAFTS_CARD_WIDTH_NARROW_COMPACT,
            },
        },
    },
};
